import React, { useEffect } from "react";
import useStyles from "../style";
import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import { renderErrorCreatePool } from "../../../utils/validate";
import { Switch } from "antd";
import { FormControlLabel } from "@material-ui/core";

function ClaimLink(props: any) {
  const classes = useStyles();
  const { setValue, errors, control, poolDetail } = props;
  const renderError = renderErrorCreatePool;

  useEffect(() => {
    if (poolDetail && poolDetail.is_claim_link) {
      setValue("is_claim_link", poolDetail.is_claim_link);
    }
  }, [poolDetail]);

  return (
    <>
      <div>
        <FormControl component="fieldset">
          <label className={classes.formControlLabel}>Claim Link</label>

          <Controller
            control={control}
            rules={{}}
            name="is_claim_link"
            render={(field) => {
              const { value, onChange } = field;
              return (
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(e) => {
                        const valueToSet = e ? 1 : 0;
                        setValue(field.name, valueToSet);
                        onChange(valueToSet);
                      }}
                      checked={!!value}
                      style={{marginLeft: "10px"}}
                    />
                  }
                  label=""
                />
              );
            }}
          />
          <p className={classes.formErrorMessage}>
            {renderError(errors, "is_claim_link")}
          </p>
        </FormControl>
      </div>
    </>
  );
}

export default ClaimLink;
